var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 24 0)",
    fill: "#2B2B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5859 9.82167C16.3669 9.04062 16.7627 8.17002 16.4698 7.87713C16.1769 7.58423 15.3063 7.97996 14.5252 8.76101L12.3231 10.9631L9.87971 8.51977C9.09866 7.73872 8.22806 7.34299 7.93517 7.63589C7.64227 7.92878 8.038 8.79938 8.81905 9.58043L11.2624 12.0238L8.86837 14.4179C8.08732 15.1989 7.6916 16.0695 7.98449 16.3624C8.27738 16.6553 9.14798 16.2596 9.92903 15.4785L12.3231 13.0845L14.4759 15.2373C15.2569 16.0183 16.1276 16.4141 16.4204 16.1212C16.7133 15.8283 16.3176 14.9577 15.5366 14.1766L13.3837 12.0238L15.5859 9.82167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.add8ed58d030d7af4f0cc210d8cba802.svg";
export { ForwardRef as ReactComponent };